import React from 'react';
import Icon from '../../../components/AppIcon';

const PriorityAlertsPanel = ({ alerts }) => {
  const getSeverityConfig = (severity) => {
    switch (severity) {
      case 'high':
        return {
          bg: 'bg-red-500/10',
          border: 'border-red-500/20',
          text: 'text-red-500',
          icon: 'AlertCircle'
        };
      case 'medium':
        return {
          bg: 'bg-orange-500/10',
          border: 'border-orange-500/20',
          text: 'text-orange-500',
          icon: 'AlertTriangle'
        };
      default:
        return {
          bg: 'bg-blue-500/10',
          border: 'border-blue-500/20',
          text: 'text-blue-500',
          icon: 'Info'
        };
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'overdue':
        return 'XCircle';
      case 'upcoming':
        return 'Clock';
      case 'at-risk':
        return 'AlertTriangle';
      default:
        return 'Info';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Priority Compliance Alerts</h3>
          <p className="text-sm text-muted-foreground">
            Critical items requiring immediate attention
          </p>
        </div>
        <div className="flex items-center gap-2 px-3 py-1.5 bg-destructive/10 border border-destructive/20 rounded-lg">
          <Icon name="Bell" size={16} color="var(--color-destructive)" />
          <span className="text-sm font-medium text-destructive">{alerts?.length} Active Alerts</span>
        </div>
      </div>

      <div className="space-y-4">
        {alerts?.map((alert) => {
          const severityConfig = getSeverityConfig(alert?.severity);
          return (
            <div
              key={alert?.id}
              className={`p-4 rounded-lg border ${severityConfig?.bg} ${severityConfig?.border}`}
            >
              <div className="flex items-start gap-4">
                <div className={`w-10 h-10 rounded-lg ${severityConfig?.bg} flex items-center justify-center flex-shrink-0`}>
                  <Icon name={getTypeIcon(alert?.type)} size={20} color={severityConfig?.text?.replace('text-', '')} />
                </div>
                <div className="flex-1">
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <h4 className="font-semibold text-foreground mb-1">{alert?.title}</h4>
                      <p className="text-sm text-muted-foreground">{alert?.description}</p>
                    </div>
                    <span className={`px-2 py-1 text-xs font-medium rounded ${severityConfig?.text} ${severityConfig?.bg} border ${severityConfig?.border}`}>
                      {alert?.severity?.toUpperCase()}
                    </span>
                  </div>
                  <div className="flex flex-wrap items-center gap-4 mt-3 text-sm">
                    <div className="flex items-center gap-1.5">
                      <Icon name="FileText" size={14} color="var(--color-muted-foreground)" />
                      <span className="text-muted-foreground">{alert?.regulation}</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <Icon name="Calendar" size={14} color="var(--color-muted-foreground)" />
                      <span className="text-muted-foreground">Due: {alert?.dueDate}</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <Icon name="MapPin" size={14} color="var(--color-muted-foreground)" />
                      <span className="text-muted-foreground">{alert?.location}</span>
                    </div>
                  </div>
                  <button className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors text-sm font-medium">
                    <Icon name="CheckCircle" size={14} />
                    {alert?.action}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PriorityAlertsPanel;